import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { StreamEvent } from '@focus/shared';

export function useStream(onEvent?: (ev: StreamEvent) => void) {
  const qc = useQueryClient();
  useEffect(() => {
    const es = new EventSource('/api/stream');

    const dispatch = (type: StreamEvent['type'], data: any) => {
      onEvent?.({ type, data } as StreamEvent);
      if (type === 'task.created' || type === 'task.updated' || type === 'task.deleted') {
        qc.invalidateQueries({ queryKey: ['tasks'] });
      }
      if (type === 'block.created' || type === 'block.updated' || type === 'block.deleted' || type === 'gcal.synced') {
        qc.invalidateQueries({ queryKey: ['blocks'] });
      }
      if (type === 'activity.event') {
        qc.invalidateQueries({ queryKey: ['activity'] });
      }
    };

    const listen = (name: StreamEvent['type']) => {
      const handler = (m: MessageEvent) => {
        try { dispatch(name, JSON.parse(m.data)); } catch {}
      };
      es.addEventListener(name, handler as any);
      return () => es.removeEventListener(name, handler as any);
    };

    const unsubs = [
      listen('task.created'), listen('task.updated'), listen('task.deleted'),
      listen('block.created'), listen('block.updated'), listen('block.deleted'),
      listen('gcal.synced'), listen('settings.updated'), listen('helper.status'),
      listen('heartbeat'), listen('activity.event'),
    ];

    es.onerror = () => {
      // browser auto-reconnects
    };
    return () => {
      unsubs.forEach((u) => u());
      es.close();
    };
  }, [qc, onEvent]);
}
